/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'
import flagStates from '@/data/flag_states.json'
import otherContent from '@/data/other_content.json'
import standards from '@/data/standards.json'
import countryCodes from '@/data/country_codes.json'
import un from '@/data/un.json'
import accountTypes from '@/data/account_types.json'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    flag_states: [],
    library: [],
    other_contents: [],
    loading_queue: [],
    country_codes: [],
    standards: [],
    un: []
  },
  mutations: {
    set_flag_states (state, payload) {
      state.flag_states = payload.data;
    },
    set_other_contents (state, payload) {
      state.other_contents = payload.data;
    },
    set_country_codes (state, payload) {
      state.country_codes = payload.data;
    },
    set_library (state, payload) {
      state.library = payload.data;
    },
    add_loading_item(state, key) {
      state.loading[key] = true;
    },
    remove_loading_item(state, key) {
      delete state.loading[key];
    },
    set_standards(state, payload) {
        state.standards = payload.data;
    },
    set_un(state, payload) {
        state.un = payload.data;
    }
  },
  actions: {
    async loadFlagStates(context) {
      context.commit('set_flag_states', { data: flagStates });
    },
    async loadOtherContents(context) {
      context.commit('set_other_contents', { data: otherContent });
    },
    async loadStandards(context) {
      context.commit('set_standards', { data: standards });
    },
    async loadCountryCodes(context) {
      context.commit('set_country_codes', { data: countryCodes });
    },
    async loadLibraries(context) {
      // separate chunk, only the library page needs it
      let libraries = await import(/* webpackChunkName: "libraries" */ '@/data/libraries.json');
      context.commit('set_library', { data: libraries.default });
    },
    async loadUN(context) {
      context.commit('set_un', { data: un });
    },

    async getAccountTypes() {
      return accountTypes;
    },

  },
  modules: {
  },
  getters: {
    getFlagStates: state => {
      return state.flag_states;
    },
    getOtherContents: state => {
      return state.other_contents;
    },
    getCountryCodes: state => {
      return state.country_codes;
    },
    getLibrary: state => {
      return state.library;
    },
    getStandards: state => {
      return state.standards;
    },
    getUN: state => {
        return state.un
    }
  }
})
